// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { productCardStyles } from "@guestsupply/Overrides/Widgets/ProductList/ProductListProductCard";
import { xScreen } from "@guestsupply/XDL/Utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productCardStyles.gridContainer = {
    gap: 0,
    css: css`
        padding: 30px 0;
        min-width: 320px; /* prevent overlap with second column */
    `,
};
productCardStyles.leftColumnGridItem = {
    width: [4, 4, 4, 3, 3],
    css: css`
        padding-right: 20px;
        flex-direction: column;
    `,
};
productCardStyles.rightColumnGridItem = {
    width: [8, 8, 8, 9, 9],
};
productCardStyles.infoGridItem = {
    width: [12, 12, 12, 7, 7],
};
productCardStyles.actionsGridItem = {
    width: [12, 12, 12, 5, 5],
};
productCardStyles.searchScoreDataGridItem = {
    width: 12,
};
productCardStyles.sponsoredText = {
    css: css`
        margin-bottom: 5px;
        font-size: 0.9em;
        opacity: 0.5;
    `,
};
productCardStyles.productListProductImageStyles = {
    compareCheckbox: {
        css: css`
            margin-top: 42px;
        `,
    },
    productImage: {
        linkWrappingImage: {
            css: css`
                position: relative;
                height: 113px;
                width: 113px;
                padding: 0;
                margin: 0 auto;
                border-radius: 4px;
            `,
        },
        img: {
            width: 100,
            height: 100,
            css: css`
                max-width: 100%;
                max-height: 100%;
                height: auto;
                object-fit: contain;
            `,
            urlOptions: "t_prdsm",
        } as any,
    },
    badgeImageWrapper: {
        css: css`
            width: 22px;
            height: 22px;
        `,
    },
};
productCardStyles.productPriceAndActionsStyles = {
    productGridContainer: {
        container: {
            css: css`
                max-width: 300px;
                width: 300px;
            `,
        },
        priceAndActions: {
            css: css`
                height: 100%;
            `,
        },
    },
};
productCardStyles.productListContainerStyles = {
    container: {
        css: css`
            border: initial;
            padding: 16px 0;
            border-bottom: 1px solid ${getColor("common.border")};
            & > .top-section {
                margin: 0;
            }
            & > .middle-section {
                flex: 1;
                margin: 0;
                padding: 0 24px 0 12px;
                border-right: 1px solid ${getColor("common.border")};
            }
            & > .bottom-section {
                margin-top: initial;
                display: flex;
                flex-direction: column;
                gap: 12px;
                ${xScreen("lte", "sm")} {
                    width: 100%;
                }
            }
            &#upsells-productcard {
                border-bottom: none;
                .product-grid-container-priceAndActions {
                    ${xScreen("lte", "sm")} {
                        width: 100%;
                        padding: 0;
                        border: none;
                        .product-grid-container {
                            width: 100%;
                            max-width: 100%;
                        }
                    }
                }
            }
        `,
    },
    image: {
        css: css`
            width: 113px;
            height: auto;
            max-height: 143px;
            margin: initial;
        `,
    },
    priceAndActions: {
        css: css`
            margin-top: initial;
            gap: 8px;
            padding-left: 24px;
        `,
    },
};
